import React, { useState } from "react"
import { useSelector, useDispatch } from "react-redux"

import { VALUE, UNLIMITED, NO, YES, NONE } from "const"
import {
    StoreType,
    ChangePackageSettings,
    setPackageSettings,
    moduleIds,
} from "client/store"
import {
    Collapse,
    PageForm,
    FormGroup,
    Label,
    RadioButton,
    Input,
} from "client/components"

const Sil = () => {
    const settings = useSelector((state: StoreType) => state.package.packageSettings)
    const moduleList = useSelector((state: StoreType) => state.module.moduleList)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const [show, setShow] = useState(false)

    const onChange = (newSettings: ChangePackageSettings) => {
        dispatch(setPackageSettings(newSettings))
    }

    const {
        silModuleAccess,
        silAccountDevices,
        silAccountDevicesValue,
        silAccountSubsystems,
        silAccountSubsystemsValue,
        silSafetyFunctions,
        silSafetyFunctionsValue,
        silCalculations,
        silCalculationsValue,
        silReports,
        silReportsValue,
    } = settings

    return (
        <Collapse
            show={show}
            title={moduleList[moduleIds.sil].name}
            onCollapse={() => setShow(!show)}
        >
            <PageForm>
                <FormGroup>
                    <Label>{lang.silMasterAccess}</Label>
                    <FormGroup inline>
                        <RadioButton
                            checked={silModuleAccess === NO}
                            onChange={() => onChange({ silModuleAccess: NO })}
                            title={lang.no}
                        />
                        <RadioButton
                            checked={silModuleAccess === YES}
                            onChange={() => onChange({ silModuleAccess: YES })}
                            title={lang.yes}
                        />
                    </FormGroup>
                </FormGroup>

                <FormGroup>
                    <Label>{lang.accountDevices}</Label>
                    <FormGroup inline>
                        <RadioButton
                            checked={silAccountDevices === NONE}
                            onChange={() => onChange({ silAccountDevices: NONE })}
                            title={lang.none}
                        />
                        <RadioButton
                            checked={silAccountDevices === VALUE}
                            onChange={() => onChange({ silAccountDevices: VALUE })}
                            title={(
                                <Input
                                    type="text"
                                    value={silAccountDevicesValue}
                                    onChange={(e) => onChange({ silAccountDevicesValue: parseInt(e.target.value, 10) || 0 })}
                                />
                            )}
                        />
                        <RadioButton
                            checked={silAccountDevices === UNLIMITED}
                            onChange={() => onChange({ silAccountDevices: UNLIMITED })}
                            title={lang.unlimited}
                        />
                    </FormGroup>
                </FormGroup>

                <FormGroup>
                    <Label>{lang.accountSubsystems}</Label>
                    <FormGroup inline>
                        <RadioButton
                            checked={silAccountSubsystems === NONE}
                            onChange={() => onChange({ silAccountSubsystems: NONE })}
                            title={lang.none}
                        />
                        <RadioButton
                            checked={silAccountSubsystems === VALUE}
                            onChange={() => onChange({ silAccountSubsystems: VALUE })}
                            title={(
                                <Input
                                    type="text"
                                    value={silAccountSubsystemsValue}
                                    onChange={(e) => onChange({ silAccountSubsystemsValue: parseInt(e.target.value, 10) || 0 })}
                                />
                            )}
                        />
                        <RadioButton
                            checked={silAccountSubsystems === UNLIMITED}
                            onChange={() => onChange({ silAccountSubsystems: UNLIMITED })}
                            title={lang.unlimited}
                        />
                    </FormGroup>
                </FormGroup>

                <FormGroup>
                    <Label>{lang.safetyFunctions}</Label>
                    <FormGroup inline>
                        <RadioButton
                            checked={silSafetyFunctions === NONE}
                            onChange={() => onChange({ silSafetyFunctions: NONE })}
                            title={lang.none}
                        />
                        <RadioButton
                            checked={silSafetyFunctions === VALUE}
                            onChange={() => onChange({ silSafetyFunctions: VALUE })}
                            title={(
                                <Input
                                    type="text"
                                    value={silSafetyFunctionsValue}
                                    onChange={(e) => onChange({ silSafetyFunctionsValue: parseInt(e.target.value, 10) || 0 })}
                                />
                            )}
                        />
                        <RadioButton
                            checked={silSafetyFunctions === UNLIMITED}
                            onChange={() => onChange({ silSafetyFunctions: UNLIMITED })}
                            title={lang.unlimited}
                        />
                    </FormGroup>
                </FormGroup>

                <FormGroup>
                    <Label>{lang.calculations}</Label>
                    <FormGroup inline>
                        <RadioButton
                            checked={silCalculations === NONE}
                            onChange={() => onChange({ silCalculations: NONE })}
                            title={lang.none}
                        />
                        <RadioButton
                            checked={silCalculations === VALUE}
                            onChange={() => onChange({ silCalculations: VALUE })}
                            title={(
                                <Input
                                    type="text"
                                    value={silCalculationsValue}
                                    onChange={(e) => onChange({ silCalculationsValue: parseInt(e.target.value, 10) || 0 })}
                                />
                            )}
                        />
                        <RadioButton
                            checked={silCalculations === UNLIMITED}
                            onChange={() => onChange({ silCalculations: UNLIMITED })}
                            title={lang.unlimited}
                        />
                    </FormGroup>
                </FormGroup>

                <FormGroup>
                    <Label>{lang.reports}</Label>
                    <FormGroup inline>
                        <RadioButton
                            checked={silReports === NONE}
                            onChange={() => onChange({ silReports: NONE })}
                            title={lang.none}
                        />
                        <RadioButton
                            checked={silReports === VALUE}
                            onChange={() => onChange({ silReports: VALUE })}
                            title={(
                                <Input
                                    type="text"
                                    value={silReportsValue}
                                    onChange={(e) => onChange({ silReportsValue: parseInt(e.target.value, 10) || 0 })}
                                />
                            )}
                        />
                        <RadioButton
                            checked={silReports === UNLIMITED}
                            onChange={() => onChange({ silReports: UNLIMITED })}
                            title={lang.unlimited}
                        />
                    </FormGroup>
                </FormGroup>
            </PageForm>
        </Collapse>
    )
}
export default Sil
